import { Units } from 'uom-units';
import { Unit } from 'uom';
import { Psi } from 'src/utils/Psi.ts';
import { BtuPerPoundPerFahrenheit } from 'src/utils/BtuPerPoundPerFahrenheit.ts';

export type TargetUnits = {
    density: Unit.Unit<'Density'>;
    heatCapacity: Unit.Unit<'SpecificHeatCapacity'>;
    ratedCapacity: Unit.Unit<'Power'>;
    temperatureDifference: Unit.Unit<'Temperature'>;
    temperature: Unit.Unit<'Temperature'>;
    volumetricFlow: Unit.Unit<'VolumeFlow'>;
    volumetricFlowAir: Unit.Unit<'VolumeFlow'>;
    massVolumetricFlow: Unit.Unit<'MassFlow'>;
    dpmv: Unit.Unit<'Pressure'>;
    dpv100: Unit.Unit<'Pressure'>;
    inletOutlet: Unit.Unit<'Pressure'>;
};

export const targetUnits: TargetUnits = {
    density: Units.KilogramPerCubicMeter,
    heatCapacity: Units.KilojoulePerKilogramKelvin,
    ratedCapacity: Units.KiloWatt,
    temperatureDifference: Units.Kelvin,
    temperature: Units.Celsius,
    volumetricFlow: Units.CubicMeterPerHour,
    volumetricFlowAir: Units.CubicMeterPerHour,
    massVolumetricFlow: Units.KilogramPerHour,
    dpmv: Units.KiloPascal,
    dpv100: Units.KiloPascal,
    inletOutlet: Units.Bar,
};
export const targetUnitsAm: TargetUnits = {
    density: Units.PoundPerCubicFoot,
    heatCapacity: BtuPerPoundPerFahrenheit,
    ratedCapacity: Units.KiloWatt,
    temperatureDifference: Units.Fahrenheit,
    temperature: Units.Fahrenheit,
    dpmv: Psi,
    dpv100: Psi,
    volumetricFlow: Units.GallonsPerMinute,
    volumetricFlowAir: Units.CubicFeetPerMinute,
    massVolumetricFlow: Units.PoundLbPerHour,
    inletOutlet: Psi,
};
